import { EntityTemplateVariables } from '@tools/interfaces/template';
import { templateContact } from '@tools/config/template-contact';
import { getResourceFieldsForEntity } from '@tools/config/template-resource';
import { getActivityFieldsForEntity } from '@tools/config/template-activity';
import { getActivityGroupFieldsForEntity } from '@tools/config/template-activity-group';

export const templateActivitySession: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.activity_sessions.code.label',
      contentValue: '{{ activity_session.code }}',
      description: 'templates.activity_sessions.code.description',
    },
    {
      label: 'templates.activity_sessions.name.label',
      contentValue: '{{ activity_session.name }}',
      description: 'templates.activity_sessions.name.description',
    },
    {
      label: 'templates.activity_sessions.start_date_time.label',
      contentValue: '{{ activity_session.start_date_time | date("d/m/Y H:i") }}',
      description: 'templates.activity_sessions.start_date_time.description',
    },
    {
      label: 'templates.activity_sessions.attendees_start_date_time.label',
      contentValue: '{{ activity_session.attendees_start_date_time | date("d/m/Y") }}',
      description: 'templates.activity_sessions.attendees_start_date_time.description',
    },
    {
      label: 'templates.activity_sessions.attendees_end_date_time.label',
      contentValue: '{{ activity_session.attendees_end_date_time | date("d/m/Y") }}',
      description: 'templates.activity_sessions.attendees_end_date_time.description',
    },
    {
      label: 'templates.activity_sessions.min_participants.label',
      contentValue: '{{ activity_session.min_participants }}',
      description: 'templates.activity_sessions.min_participants.description',
    },
    {
      label: 'templates.activity_sessions.max_participants.label',
      contentValue: '{{ activity_session.max_participants }}',
      description: 'templates.activity_sessions.max_participants.description',
    },
  ],
  related: [
    {
      relationName: 'bpcActivity',
      relationType: 'simple',
      label: 'templates.activity_sessions.activity.label',
      description: 'templates.activity_sessions.activity.description',
      fields: getActivityFieldsForEntity('activity_session.'),
    },
    {
      relationName: 'activityGroup',
      relationType: 'simple',
      label: 'templates.activity_sessions.activity_group.label',
      description: 'templates.activity_sessions.activity_group.description',
      fields: getActivityGroupFieldsForEntity('activity_session.'),
    },
    {
      relationName: 'resource',
      relationType: 'simple',
      label: 'templates.activity_sessions.resource.label',
      description: 'templates.activity_sessions.resource.description',
      fields: getResourceFieldsForEntity('activity_session.'),
    },
  ],
  relatedInLoop: [
    {
      relationName: 'contact',
      relationType: 'inLoop',
      label: 'templates.activity_sessions.responsibles.label',
      description: 'templates.activity_sessions.responsibles.description',
      blockStartValue: '{% for contact in activity_session.responsibles %}',
      contentValue: '{# Add some contact fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateContact.fields,
    },
  ],
};
